export const PDF_FONT_CONFIG = {
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
  },
};

export const storageUrl = 'https://sazbspmprd.blob.core.windows.net/static-images-report/';

const placeholders: { [key: string]: string } = {
  cover: '',
  asset: '',
};

export const getImageFromName = async (fileName: string, type?: string): Promise<string> => {
  const url = storageUrl + fileName;

  return new Promise((resolve, _reject) => {
    fetch(url)
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        if (blob.type.indexOf('image') > -1) {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (reader.result) {
              resolve(reader.result as string);
            }
          };
          reader.readAsDataURL(blob);
        } else {
          resolve(placeholders[type as string]);
        }
      });
  });
};